import React from "react";
import cssClass from "./ClinicBookingForm.module.scss";

const ClinicBookingForm = ({ isFree = true }) => {
  return (
    <div className={cssClass.formContainer}>
      <div className={cssClass.titleContainer}>
        <h3>Request first appointment</h3>
        {isFree && <p>Free</p>}
      </div>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className={cssClass.inputGroup}>
          <label htmlFor="name">Your Name</label>
          <input required id="name" placeholder="First and last name" />
        </div>
        <div className={cssClass.inputGroup}>
          <label htmlFor="email">Email</label>
          <input
            required
            type="email"
            id="email"
            placeholder="youremail@email.com"
          />
        </div>
        <div className={cssClass.inputGroup}>
          <label htmlFor="phone-number">Phone Number</label>
          <span id="phone-number-hint">Please include your contry code</span>
          <div className={cssClass.phoneNumberInputContainer}>
            <input
              className={cssClass.countryCodeInput}
              required
              placeholder="+45"
              // TODO: add "+" as a pseudoelement to `value`?
            />
            <input
              className={cssClass.phoneNumberInput}
              required
              type="tel"
              aria-describedby="phone-number-hint"
              id="phone-number"
              placeholder="0000000"
            />
          </div>
        </div>
        <div className={cssClass.checkboxGroup}>
          <input id="data-protection-checkbox" type="checkbox" />
          <label htmlFor="data-protection-checkbox">
            I hereby accept the terms of the data protection clause
          </label>
        </div>
        <input type="submit" />
      </form>
      {/* TODO: state, controls, post-submitted view */}
    </div>
  );
};

export default ClinicBookingForm;
